/*eslint no-console: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import ChannelIcon from '../channel-defs/ChannelIcon.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {FullScreenPanel} from './EmbededPanel.react';
import DataSetListDetail from '../data-sets/DataSetListDetail.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import EventTracker from '../app/EventTracker';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface MenuChannelProps {
    relay?: object;
    user: User;
}

class MenuChannel extends React.Component<MenuChannelProps> {

    typeName = 'channels';

    static propTypes = {
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    getUrl = (item) => {
        let server = window.config['app-url'];

        return server + urlMapping.getUrl(types['dataSets'], 'view', item);
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }


    render() {
        const data = this.props.user.organisation.channel;

        let title = data.name;
        if (!title) {
            title = data.channelDef.name;
        }

        return (
            <FullScreenPanel hideMenu showBackToPanel typeForTest="menu-channel">
                <div className="bordered-content">
                    <h2><div style={{display: "inline-block", marginRight: ".5em"}}><ChannelIcon channelDef={data.channelDef} size={128}/></div> {title}</h2>
                    {this.props.user.organisation.description ? <p className="grey">{this.props.user.organisation.description}</p> : null}

                    <DataSetListDetail
                        dataSets={data.dataSets}
                        sourceGroupDefs={data.channelDef.sourceGroupDefs}
                    />
                </div>
            </FullScreenPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(MenuChannel, (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                ${EventTracker.getFragment()},
                organisation(id: $organisationId) {
                    id,
                    realId,
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        type,
                        cachingStatus,
                        description,
                        name,
                        channelDef {
                            id,
                            name,
                            icon,
                            extendedFrom_id,
                            extendedFrom {
                                id,
                                realId,
                                icon
                            },
                            sourceGroupDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        name,
                                        priority,
                                        importance
                                    }
                                }
                            }
                        },
                        dataSets(first: 200) {
                            edges {
                                node {
                                    id,
                                    channel_id,
                                    organisation_id,
                                    storeInfo {
                                        id,
                                        status,
                                        hasAnyData,
                                    }
                                    channel {
                                        id,
                                        name
                                    },
                                    sourceDef {
                                        id,
                                        name,
                                        sourceGroupDef_id,
                                    },
                                    channelDef {
                                        id,
                                        name
                                    },
                                    entityDef {
                                        id,
                                        name
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }

                        }
                    }
                }
            }
        `,
    },
});
